<script setup lang="ts">
import EventsBreadcrumbBand from './EventsBreadcrumbBand.vue';
import EventsGalleryDetailHero from './EventsGalleryDetailHero.vue';
import EventsRelatedGalleries from './EventsRelatedGalleries.vue';
import { EVENTS_GALLERY_DETAIL_CONFIG } from '../lib/gallery-detail.const';
import {
  EVENTS_ROUTE_NAMES,
  type EventMediaMode,
} from '~/shared/lib/events-routes.const';
import type { GalleryListItem } from '~/shared/api/client/galleries/galleries.dto';

const props = defineProps<{
  mode: EventMediaMode;
  title: string;
  pageUrl: string;
  isPending: boolean;
  hasGallery: boolean;
  relatedGalleries: GalleryListItem[];
}>();

const config = computed(() => EVENTS_GALLERY_DETAIL_CONFIG[props.mode]);
const breadcrumbItems = computed(() => [
  { label: 'Главная', to: '/' },
  {
    label: 'Мероприятия',
    to: { name: EVENTS_ROUTE_NAMES.afisha },
  },
  {
    label: config.value.breadcrumbLabel,
    to: { name: config.value.listRouteName },
  },
]);
</script>

<template>
  <div :class="$style.page">
    <EventsBreadcrumbBand :items="breadcrumbItems" />

    <div v-if="isPending" :class="$style.state">
      <Loader />
    </div>

    <template v-else-if="hasGallery">
      <EventsGalleryDetailHero :title="title" :page-url="pageUrl" />

      <section :class="$style.section">
        <div :class="$style.inner">
          <slot />
        </div>
      </section>

      <EventsRelatedGalleries :mode="mode" :galleries="relatedGalleries" />
    </template>

    <div v-else :class="$style.state">
      <span :class="$style.stateText">{{ config.notFoundText }}</span>
    </div>
  </div>
</template>

<style module lang="scss">
.page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: var(--color-white);
}

.inner {
  width: 100%;
  max-width: 860px;
}

.section {
  display: flex;
  padding: 30px 110px;
}

.state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  padding: 60px 20px;
}

.stateText {
  @include text_body1;
  margin: 0;
  color: var(--color-gray-text);
}

@media (max-width: 1379px) {
  .section {
    padding-left: 20px;
    padding-right: 20px;
  }

  .inner {
    max-width: none;
  }
}

@media (max-width: 479px) {
  .section {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
